module.exports = __webpack_public_path__ + "img/step2.79bc9352.svg";